import apiClient from "../../utils/apiclient";

// export const dashboard=async(reqBody:{
//     task_id:string;
//     location: string
//     day:string;
  
//  },token:string)=>{
//    return await apiClient.post('/dashboard/dashboard_V1',reqBody,{
//       headers:{
//          Authorization: `Bearer ${token}`
//       }
//    })
//  }
 export const dashboarddetails=async(reqBody:{
   task_id:string;
   location: string
   day:string;
 
   
   
},token:string)=>{
  return await apiClient.post('/dashboard/dashboard_V1',reqBody,{
     headers:{
          Authorization: `Bearer ${token}`
     }
  })

  
}


export const getdropdowntaskname=async()=>{
   return await apiClient.get('/admin/task/get_taskname_dropname',{
     
   })
 }
export const getalllocations=async()=>{
   return await apiClient.get('/city/distinctcity',{
    
   })
}

export const dashboardPriority = async (reqBody: {
   task_not_completed: boolean;
   task_pending:boolean
   isexport:boolean,
   filters:{
      location: string | null,
      task_name: string | null
  }
   
}, token: string) => {
   return await apiClient.post('/dashboard/priority-users_v1', reqBody, {
      headers: {
         Authorization: `Bearer ${token}`
      }
   })
}
export const getfilterdata1 = async (token:string) => {
   return await apiClient.get(`/reports/get-filter-data_v1`, {headers:{Authorization: `Bearer ${token}`}});
 };



export const dashboardPendingTask = async (reqBody: {
   task_pending: boolean;
}, token: string) => {
   return await apiClient.post('/dashboard/priority-users_v1', reqBody, {
      headers: {
         Authorization: `Bearer ${token}`
      }
   })
}

 